export const getCurrencyInfo = (country: string) => ({
  symbol: country === 'gb' ? '£' : '$',
  amount: country === 'gb' ? '12' : '14',
});
